import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="container-x py-32 text-center" data-testid="not-found-page">
      <p className="eyebrow">404</p>
      <h1 className="mt-4 t-h1">This page isn't in our panel.</h1>
      <p className="mt-4 text-[var(--ink-3)]">The address may be outdated or the broker may have been removed.</p>
      <Link to="/" className="btn-primary mt-10">Back to home <ArrowRight size={16} /></Link>
    </div>
  );
}
